export const GET_DAY_DISPONIBLE = 'GET_DAY_DISPONIBLE'
export const GET_DAY_DISPONIBLE_SUCCESS = 'GET_DAY_DISPONIBLE_SUCCESS'
export const GET_DAY_DISPONIBLE_FAILURE = 'GET_DAY_DISPONIBLE_FAILURE'
export const RESET_DAY_DISPONIBLE = 'RESET_DAY_DISPONIBLE'

export const GET_DAY_DISPONIBILITES = 'GET_DAY_DISPONIBILITES'
export const GET_DAY_DISPONIBILITES_SUCCESS = 'GET_DAY_DISPONIBILITES_SUCCESS'
export const GET_DAY_DISPONIBILITES_FAILURE = 'GET_DAY_DISPONIBILITES_FAILURE'
